var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-content-center p-4 align-middle"},[_c('b-spinner',{attrs:{"variant":"primary","label":"Loading..."}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }